module.exports = __webpack_public_path__ + "img/section5-index.7dbb87b6.png";